
import React from 'react';
import { Shield, Zap, TrendingUp, Search, Lock, Users, Briefcase, Globe, Target, BarChart3, AlertCircle, BookOpen, CheckSquare, XCircle, UserCheck } from 'lucide-react';

export const STACK_ITEMS = [
  {
    title: 'Ebook "El Método Paso a Paso"',
    desc: 'El manual de 15 páginas sin relleno con los 6 filtros de calidad.',
    value: '$47.00',
    icon: <BookOpen className="text-gold w-8 h-8" />
  },
  {
    title: 'La Checklist de 30 Minutos',
    desc: 'La misma que uso para descartar el 95% de las acciones basura.',
    value: '$27.00',
    icon: <CheckSquare className="text-blue-400 w-8 h-8" />
  },
  {
    title: 'Guía Visual de MOATs',
    desc: 'Cómo identificar "ventajas injustas" antes que el mercado.',
    value: '$23.00',
    icon: <Shield className="text-green-400 w-8 h-8" />
  }
];

export const MAIN_OFFER = {
  name: 'Invesmart - El Método',
  price: '$6.99',
  originalValue: '$97.00',
  cta: 'SÍ, QUIERO EL MÉTODO POR $6.99',
  hotmartLink: 'https://pay.hotmart.com/O104410447K'
};

export const TESTIMONIALS = [
  {
    quote: "Confundía trading con inversion hasta que usé la checklist. En 15 minutos descarté basura que casi compro.",
    author: "Juan Manuel L.",
    role: "Empleado Administrativo",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop"
  },
  {
    quote: "Por 7usd no esperaba tanto. La guía de moats vale ella sola los $97 que pedían al principio.",
    author: "Agustina R.",
    role: "Contadora Pública",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop"
  },
  {
    quote: "lo mejor es que no necesitas Bloomberg ni herramientas caras. Con Yahoo Finance y este método sobra.",
    author: "Gonzalo T.",
    role: "Ingeniero Industrial",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop"
  }
];

export const QUALIFIERS = {
  isFor: [
    "Ahorradores que quieren que su dinero trabaje, no que se oxide.",
    "Personas sin tiempo que necesitan un sistema de 15 minutos.",
    "Inversores que buscan fundamentos, no 'señales' de Telegram.",
    "Gente que quiere entender QUÉ compra y POR QUÉ lo compra."
  ],
  isNotFor: [
    "Gente que busca hacerse rica de la noche a la mañana.",
    "Personas que prefieren apostar a invertir.",
    "Quienes no están dispuestos a leer 15 páginas de puro valor.",
    "Inversores que solo buscan el próximo 'Dogecoin'."
  ]
};

export const AUTHORITY_CONTENT = {
  name: "Invesmart",
  title: "¿Qué es Invesmart?",
  image: "https://i.ibb.co/wFGm4kfV/image.png",
  bio: "No somos gestores de fondos que viven de comisiones. Somos inversores que arriesgan su propio capital. Después de 10 años en los mercados y ver a cientos de personas perder sus ahorros por consejos mediocres, decidimos empaquetar nuestro proceso interno en un sistema que cualquiera pueda seguir.",
  stats: [
    { label: "+60 Alumnos", icon: <UserCheck className="w-5 h-5 text-[#8b5cf6]" /> },
    { label: "Ratio de Éxito > 80%", icon: <Target className="w-5 h-5 text-[#8b5cf6]" /> }
  ]
};
